import EnterpriseUsersTable from '@organisms/Tables/Enterprise/UsersTable/EnterpriseUsersTable';

const EnterpriseUsers = () => {
  return <EnterpriseUsersTable />;
};

export default EnterpriseUsers;
